import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationMembersPage } from "src/pages/OrganizationMembersPage";
import { organizationMembersQueryOptions } from "src/queries/organizationMembers";

export const ORGANIZATION_MEMBERS_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().optional(),
  ps: z.coerce.number().optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/members",
)({
  component: OrganizationMembersPage,
  validateSearch: searchSchema,
  ssr: true,
  loaderDeps: ({ search }) => ({
    pageIndex: search.p || 0,
    pageSize: search.ps || ORGANIZATION_MEMBERS_DEFAULT_PAGE_SIZE,
    query: search.q || "",
  }),
  async loader({ context, deps, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        await context.queryClient.query({
          ...organizationMembersQueryOptions(organization.id, deps),
          staleTime: "static",
        });
        return { data: null };
      },
    );
  },
});
